export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "seller_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prime vendeur"])},
        "manager_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prime manager"])},
        "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])}
      },
      "en": {
        "seller_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seller commission"])},
        "manager_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manager commission"])},
        "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])}
      }
    }
  })
}
